import { render } from "./client-list-page.vue?vue&type=template&id=6d242578&scoped=true"
import script from "./client-list-page.vue?vue&type=script&lang=js"
export * from "./client-list-page.vue?vue&type=script&lang=js"

import "./client-list-page.vue?vue&type=style&index=0&id=6d242578&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d242578"]])

export default __exports__